import {Container, Grid, Hidden, Theme, useMediaQuery} from '@material-ui/core';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import noop from 'lodash/noop';
import {WithTranslation, withTranslation} from 'react-i18next';

import Map from 'src/Components/Common/FooterBar/Map';

import ContactUsForm from './ContactUsForm/ContactUsForm';
import {contactUsStyles} from './ContactUsStyles';

const ContactUs = (props: IContactUsProps) => {
	const matches = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

	return (
		<section className={props.classes.root}>
			<Container maxWidth="lg" disableGutters={matches}>
				<Grid container spacing={matches ? 0 : 2}>
					<Hidden smDown>
						<Grid item md={1} />
					</Hidden>
					<Grid item xs={12} sm={7} md={6}>
						<ContactUsForm onCloseModal={noop} />
					</Grid>
					<Grid item md={1} />
					{!matches && <Map />}
					<Hidden smDown>
						<Grid item md={1} />
					</Hidden>
				</Grid>
			</Container>
		</section>
	);
};

interface IContactUsProps extends WithTranslation, WithStyles {}

export default withStyles(contactUsStyles)(withTranslation('contactus')(ContactUs));
